import { Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IReportFeedback } from '../../models/report-feedback.model';
import { DIALOG_BUTTONS } from '../../constants';

@Component({
  selector: 'app-report-feedback-dialog',
  templateUrl: './report-feedback-dialog.component.html',
  styleUrls: ['./report-feedback-dialog.component.scss'],
  standalone: false,
})
export class ReportFeedbackDialogComponent {
  data = inject<IReportFeedback>(MAT_DIALOG_DATA);
  translate = inject(TranslateService);

  readonly buttons = DIALOG_BUTTONS;

  constructor() {
    const translate = this.translate;

    this.data.showCancelButton = this.data.showCancelButton ?? true;
    translate.addLangs(['en']);
    translate.setDefaultLang('en');
    const browserLang = translate.getBrowserLang();
    translate.use(browserLang.match(/en/) ? browserLang : 'en');
  }
}
